import { loginreq,req2 } from './axiosFun';

// 登錄接口 
export const login = (params) => { return loginreq("post", "auth/login", params) };
// 获取用户菜单

// 退出接口

export const getData = (params) => { return req2("get", "/index/article/getData", params) };

export const getTableColumns = (params) => { return req2("get", "/index/article/getTableColumns", params) };

export const getJsdata = (params) => { return req2("get", "/index/article/getJsData", params) };


export const removeJSdata = (params) => { return req2("post", "/index/article/removeJSdata", params) };


export const saveJsdata = (params) => { return req2("post", "/index/article/saveJsdata", params) };